import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const API_URL = 'https://dear-bea-website.onrender.com';

  const handleLogout = async () => {
  try {
    await fetch(`${API_URL}/api/admin/logout`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${window.adminToken}`
      }
    });
  } catch (error) {
    console.error('Logout error:', error);
  }
  
  delete window.adminToken;
  navigate('/admin/login');
};
  const [orders, setOrders] = useState([]);
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('orders'); // 'orders' or 'inquiries'
  const [reviews, setReviews] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);



  // Fetch orders and inquiries from backend
  useEffect(() => {
    fetchOrders();
    fetchInquiries();
    fetchReviews();
    fetchSubscriptions();

    const interval = setInterval(() => {
      fetchOrders();
      fetchInquiries();
      fetchReviews();
      fetchSubscriptions();
    }, 30000); // 30 seconds


  return () => clearInterval(interval);
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await fetch(`${API_URL}/api/orders`, {
        headers: {
    'Authorization': `Bearer ${window.adminToken}`
  }
      });
      const data = await response.json();
      setOrders(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching orders:', error);
      setLoading(false);
    }
  };

   const fetchReviews = async () => {
    try {
      const response = await fetch(`${API_URL}/api/reviews`, {
        headers: {
    'Authorization': `Bearer ${window.adminToken}`
      }
      });
      const data = await response.json();
      if (data.success) {
        setReviews(data.reviews);
      }
    } catch (error) {
      console.error('Error fetching reviews:', error);
    }
  };

  const fetchSubscriptions = async () => {
  try {
    const response = await fetch(`${API_URL}/api/subscriptions`, {
      headers: {
    'Authorization': `Bearer ${window.adminToken}`
  }

    });
    const data = await response.json();
    if (data.success) {
      setSubscriptions(data.subscriptions);
    }
  } catch (error) {
    console.error('Error fetching subscriptions:', error);
  }
};

  // ← ADD THIS FUNCTION
  const handleReviewStatusChange = async (reviewId, newStatus) => {
    try {
      const response = await fetch(`${API_URL}/api/reviews/${reviewId}/status`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.adminToken}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      const data = await response.json();

      if (data.success) {
        setReviews(reviews.map(review =>
          review.id === reviewId ? { ...review, status: newStatus } : review
        ));
      }
    } catch (error) {
      console.error('Error updating review status:', error);
    }
  };

  const fetchInquiries = async () => {
    try {
      const response = await fetch(`${API_URL}/api/inquiries`, {
        headers: {
          'Authorization': `Bearer ${window.adminToken}`
        }
      });
      const data = await response.json();
      setInquiries(data);
    } catch (error) {
      console.error('Error fetching inquiries:', error);
    }
  };

  // Update order status
  const updateOrderStatus = async (orderId, newStatus) => {
    try {
      const response = await fetch(`${API_URL}/api/orders/${orderId}/status`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.adminToken}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (response.ok) {
        fetchOrders();
        alert('Order status updated!');
      }
    } catch (error) {
      console.error('Error updating order:', error);
    }
  };

  // Delete order
const deleteOrder = async (orderId, orderNumber) => {
  if (!window.confirm(`Are you sure you want to delete order ${orderNumber}? This cannot be undone.`)) {
    return;
  }

  try {
    const response = await fetch(`${API_URL}/api/orders/${orderId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${window.adminToken}`,
      },
    });

    const data = await response.json();

    if (data.success) {
      // Close modal if it's open
      setSelectedOrder(null);
      // Refresh orders list
      await fetchOrders();
      alert('Order deleted successfully!');
    } else {
      alert('Failed to delete order: ' + data.error);
    }
  } catch (error) {
    console.error('Error deleting order:', error);
    alert('Error deleting order');
  }
};

  // Update inquiry status
  const updateInquiryStatus = async (inquiryId, newStatus) => {
    try {
      const response = await fetch(`${API_URL}/api/inquiries/${inquiryId}/status`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.adminToken}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (response.ok) {
        fetchInquiries();
        alert('Inquiry status updated!');
      }
    } catch (error) {
      console.error('Error updating inquiry:', error);
    }
  };


  // Filter orders
  const filteredOrders = orders.filter(order => {
    const matchesFilter = filter === 'all' || order.order_status === filter;
    const matchesSearch = 
      order.order_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.last_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.email.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesFilter && matchesSearch;
  });

console.log('🔍 Total orders:', orders.length);
console.log('🔍 Filtered orders:', filteredOrders.length);
console.log('🔍 Active filter:', filter);
console.log('🔍 Search term:', searchTerm);

  // Calculate stats
  const stats = {
    total: orders.length,
    pending: orders.filter(o => o.order_status === 'pending').length,
    confirmed: orders.filter(o => o.order_status === 'confirmed').length,
    delivered: orders.filter(o => o.order_status === 'delivered').length,
    totalRevenue: orders.reduce((sum, o) => sum + parseFloat(o.total), 0),
  };

  const inquiryStats = {
    total: inquiries.length,
    new: inquiries.filter(i => i.status === 'new').length,
    responded: inquiries.filter(i => i.status === 'responded').length,
    closed: inquiries.filter(i => i.status === 'closed').length,
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-soft flex items-center justify-center">
        <div className="text-center">
          <svg className="animate-spin h-12 w-12 text-rose-600 mx-auto mb-4" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <p className="text-gray-600 text-lg font-sans">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-soft py-6 md:py-12">
      <div className="max-w-7xl mx-auto px-4">
        
        {/* Header */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6 md:mb-8">
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-6xl font-display font-bold text-gray-900 mb-1 md:mb-2">
              Admin Dashboard
            </h1>
            <p className="text-sm md:text-base text-gray-600 font-sans">Manage your orders and customers</p>
          </div>
            {/* ✅ ADD THIS REFRESH BUTTON */}
    <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
    <button
      onClick={() => {
        setLoading(true);
        fetchOrders();
        fetchInquiries();
        fetchReviews();
        fetchSubscriptions();
      }}
      className="bg-blue-600 hover:bg-blue-700 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg md:rounded-xl font-semibold transition flex items-center justify-center gap-2 text-sm md:text-base"
      disabled={loading}
    >
      {loading ? (
        <>
          <svg className="animate-spin h-4 w-4 md:h-5 md:w-5" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          Refreshing...
        </>
      ) : (
        <>
          🔄 Refresh
        </>
      )}
    </button>
     {/* ADD HERE */}
    <button
      onClick={() => navigate('/admin/add-product')}
      className="bg-rose-600 hover:bg-rose-700 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg md:rounded-xl font-semibold transition text-sm md:text-base"
    >
      + Add Product
    </button>
          <button
            onClick={() => navigate('/')}
            className="btn-primary"
          >
            ← Back to Store
          </button>
        </div>
      </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 lg:gap-6 mb-6 md:mb-8">
          <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-rose-600 hover-lift">
            <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Total Orders</p>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{stats.total}</p>
          </div>
          <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-yellow-500 hover-lift">
            <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Pending</p>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{stats.pending}</p>
          </div>
          <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-blue-500 hover-lift">
            <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Confirmed</p>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{stats.confirmed}</p>
          </div>
          <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-green-500 hover-lift">
            <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Delivered</p>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{stats.delivered}</p>
          </div>
          <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-purple-500 hover-lift col-span-2 md:col-span-1">
            <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Total Revenue</p>
            <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">${stats.totalRevenue.toFixed(2)}</p>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex flex-col sm:flex-row gap-2 md:gap-4 mb-6 md:mb-8">
          <button
            onClick={() => setActiveTab('orders')}
            className={`px-4 md:px-6 lg:px-8 py-3 md:py-4 rounded-xl md:rounded-2xl font-semibold font-sans transition-all duration-300 text-sm md:text-base ${
              activeTab === 'orders'
                ? 'bg-gradient-rose text-white shadow-romantic scale-105'
                : 'bg-white text-gray-700 hover:bg-rose-50 shadow-soft'
            }`}
          >
            Orders ({orders.length})
          </button>
          <button
            onClick={() => setActiveTab('inquiries')}
            className={`px-4 md:px-6 lg:px-8 py-3 md:py-4 rounded-xl md:rounded-2xl font-semibold font-sans transition-all duration-300 text-sm md:text-base ${
              activeTab === 'inquiries'
                ? 'bg-gradient-rose text-white shadow-romantic scale-105'
                : 'bg-white text-gray-700 hover:bg-rose-50 shadow-soft'
            }`}
          >
            Inquiries ({inquiries.length})
          </button>
          <button
            onClick={() => setActiveTab('reviews')}
            className={`px-4 md:px-6 lg:px-8 py-3 md:py-4 rounded-xl md:rounded-2xl font-semibold font-sans transition-all duration-300 text-sm md:text-base ${
              activeTab === 'reviews'
                ? 'bg-gradient-rose text-white shadow-romantic scale-105'
                : 'bg-white text-gray-700 hover:bg-rose-50 shadow-soft'
            }`}
          >
            Reviews ({reviews.filter(r => r.status === 'pending').length} pending)
          </button>
          
          <button
  onClick={() => setActiveTab('subscriptions')}
  className={`px-4 md:px-6 lg:px-8 py-3 md:py-4 rounded-xl md:rounded-2xl font-semibold font-sans transition-all duration-300 text-sm md:text-base ${
    activeTab === 'subscriptions'
      ? 'bg-gradient-rose text-white shadow-romantic scale-105'
      : 'bg-white text-gray-700 hover:bg-rose-50 shadow-soft'
  }`}
>
  Subscriptions ({subscriptions.length})
</button>

        </div>

        {/* Conditional Content */}
        {activeTab === 'orders' ? (
          <>
            {/* Filters and Search */}
            <div className="card-romantic p-4 md:p-6 mb-6 md:mb-8">
              <div className="flex flex-col gap-3 md:gap-4">
                <div className="w-full">
                  <input
                    type="text"
                    placeholder="Search orders..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="input-romantic text-sm md:text-base"
                  />
                </div>

                {/* Filter Buttons */}
                <div className="flex gap-2">
                  <button
                    onClick={() => setFilter('all')}
                    className={`px-6 py-3 rounded-xl font-semibold font-sans transition ${
                      filter === 'all'
                        ? 'bg-rose-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    All
                  </button>
                  <button
                    onClick={() => setFilter('pending')}
                    className={`px-6 py-3 rounded-xl font-semibold font-sans transition ${
                      filter === 'pending'
                        ? 'bg-yellow-500 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Pending
                  </button>
                  <button
                    onClick={() => setFilter('confirmed')}
                    className={`px-6 py-3 rounded-xl font-semibold font-sans transition ${
                      filter === 'confirmed'
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Confirmed
                  </button>
                  <button
                    onClick={() => setFilter('delivered')}
                    className={`px-6 py-3 rounded-xl font-semibold font-sans transition ${
                      filter === 'delivered'
                        ? 'bg-green-500 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Delivered
                  </button>
                </div>
              </div>
            </div>

            {/* Orders Table */}
            {/* Mobile Card View */}
            <div className="space-y-3 md:hidden">
              {filteredOrders.length === 0 ? (
                <div className="card-romantic p-8 text-center text-gray-500 font-sans">
                  No orders found
                </div>
              ) : (
                filteredOrders.map((order) => (
                  <div key={order.id} className="card-romantic p-4">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <p className="font-mono font-bold text-rose-600 text-sm">{order.order_number}</p>
                        <p className="text-xs text-gray-500 font-sans">
                          {new Date(order.created_at).toLocaleDateString()}
                        </p>
                      </div>
                      <span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold font-sans ${
                        order.order_status === 'pending'
                          ? 'bg-yellow-100 text-yellow-800'
                          : order.order_status === 'confirmed'
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-green-100 text-green-800'
                      }`}>
                        {order.order_status.charAt(0).toUpperCase() + order.order_status.slice(1)}
                      </span>
                    </div>
                    
                    <div className="space-y-2 mb-3">
                      <div>
                        <p className="text-xs text-gray-500 font-sans">Customer</p>
                        <p className="font-semibold text-sm text-gray-900 font-sans">
                          {order.first_name} {order.last_name}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 font-sans">Delivery</p>
                        <p className="text-sm text-gray-900 font-sans">
                          {new Date(order.delivery_date).toLocaleDateString('en-AU', {
                            month: 'short',
                            day: 'numeric',
                          })} - {order.delivery_time}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 font-sans">Total</p>
                        <p className="font-bold text-lg text-gray-900">${order.total}</p>
                      </div>
                    </div>
                    
                    <button
                      onClick={() => setSelectedOrder(order)}
                      className="w-full bg-rose-600 hover:bg-rose-700 text-white py-2 rounded-lg text-sm font-semibold transition"
                    >
                      View Details
                    </button>
                  </div>
                ))
              )}
            </div>

            {/* ✅ Desktop Table View - COMPLETE */}
            <div className="hidden md:block card-romantic overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b-2 border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider font-sans">
                        Order #
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider font-sans">
                        Customer
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider font-sans">
                        Delivery Date
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider font-sans">
                        Total
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider font-sans">
                        Status
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider font-sans">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {filteredOrders.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="px-6 py-12 text-center text-gray-500 font-sans">
                          No orders found
                        </td>
                      </tr>
                    ) : (
                      filteredOrders.map((order) => (
                        <tr key={order.id} className="hover:bg-gray-50 transition">
                          <td className="px-6 py-4">
                            <p className="font-mono font-semibold text-rose-600">{order.order_number}</p>
                            <p className="text-xs text-gray-500 font-sans">
                              {new Date(order.created_at).toLocaleDateString()}
                            </p>
                          </td>
                          <td className="px-6 py-4">
                            <p className="font-semibold text-gray-900 font-sans">
                              {order.first_name} {order.last_name}
                            </p>
                            <p className="text-sm text-gray-600 font-sans">{order.email}</p>
                            <p className="text-sm text-gray-600 font-sans">{order.phone}</p>
                          </td>
                          <td className="px-6 py-4">
                            <p className="font-semibold text-gray-900 font-sans">
                              {new Date(order.delivery_date).toLocaleDateString('en-AU', {
                                weekday: 'short',
                                month: 'short',
                                day: 'numeric',
                              })}
                            </p>
                            <p className="text-sm text-gray-600 font-sans">{order.delivery_time}</p>
                          </td>
                          <td className="px-6 py-4">
                            <p className="font-bold text-lg text-gray-900">${order.total}</p>
                          </td>
                          <td className="px-6 py-4">
                            <span className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold font-sans ${
                              order.order_status === 'pending'
                                ? 'bg-yellow-100 text-yellow-800'
                                : order.order_status === 'confirmed'
                                ? 'bg-blue-100 text-blue-800'
                                : 'bg-green-100 text-green-800'
                            }`}>
                              {order.order_status.charAt(0).toUpperCase() + order.order_status.slice(1)}
                            </span>
                          </td>
                          <td className="px-6 py-4">
                            <button
                              onClick={() => setSelectedOrder(order)}
                              className="text-rose-600 hover:text-rose-700 font-semibold font-sans mr-4"
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : activeTab === 'inquiries' ? (
          <>
            {/* Inquiries Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 lg:gap-6 mb-6 md:mb-8">
              <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-blue-600 hover-lift">
                <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Total Inquiries</p>
                <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{inquiryStats.total}</p>
              </div>
              <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-purple-500 hover-lift">
                <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">New</p>
                <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{inquiryStats.new}</p>
              </div>
              <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-green-500 hover-lift">
                <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Responded</p>
                <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{inquiryStats.responded}</p>
              </div>
              <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-gray-500 hover-lift">
                <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Closed</p>
                <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{inquiryStats.closed}</p>
              </div>
            </div>

            {/* Mobile Card View */}
            <div className="space-y-3 md:hidden">
              {inquiries.length === 0 ? (
                <div className="card-romantic p-8 text-center text-gray-500 font-sans">
                  No inquiries yet
                </div>
              ) : (
                inquiries.map((inquiry) => (
                  <div key={inquiry.id} className="card-romantic p-4">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <p className="font-semibold text-gray-900 font-sans">{inquiry.name}</p>
                        <p className="text-xs text-gray-500 font-sans">
                          {new Date(inquiry.created_at).toLocaleDateString()}
                        </p>
                      </div>
                      <span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold font-sans ${
                        inquiry.status === 'new'
                          ? 'bg-blue-100 text-blue-800'
                          : inquiry.status === 'responded'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-800'
                      }`}>
                        {inquiry.status}
                      </span>
                    </div>
                    
                    <div className="space-y-2 mb-3">
                      <p className="text-sm text-gray-700 font-sans">{inquiry.email}</p>
                      <p className="text-sm text-gray-700 font-sans line-clamp-2">{inquiry.message}</p>
                    </div>
                    
                    <select
                      value={inquiry.status}
                      onChange={(e) => updateInquiryStatus(inquiry.id, e.target.value)}
                      className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-rose-600 focus:outline-none text-sm font-sans"
                    >
                      <option value="new">New</option>
                      <option value="responded">Responded</option>
                      <option value="closed">Closed</option>
                    </select>
                  </div>
                ))
              )}
            </div>

            {/* ✅ Desktop Inquiries Table - COMPLETE */}
            <div className="hidden md:block card-romantic overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b-2 border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Date
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Name
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Email
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Phone
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Message
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Status
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {inquiries.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="px-6 py-12 text-center text-gray-500 font-sans">
                          No inquiries yet
                        </td>
                      </tr>
                    ) : (
                      inquiries.map((inquiry) => (
                        <tr key={inquiry.id} className="hover:bg-gray-50 transition">
                          <td className="px-6 py-4">
                            <p className="text-sm text-gray-900 font-sans">
                              {new Date(inquiry.created_at).toLocaleDateString()}
                            </p>
                            <p className="text-xs text-gray-500 font-sans">
                              {new Date(inquiry.created_at).toLocaleTimeString()}
                            </p>
                          </td>
                          <td className="px-6 py-4">
                            <p className="font-semibold text-gray-900 font-sans">{inquiry.name}</p>
                          </td>
                          <td className="px-6 py-4">
                            <p className="text-gray-700 font-sans">{inquiry.email}</p>
                          </td>
                          <td className="px-6 py-4">
                            <p className="text-gray-700 font-sans">{inquiry.phone || '-'}</p>
                          </td>
                          <td className="px-6 py-4 max-w-xs">
                            <p className="text-gray-700 truncate font-sans whitespace-pre-wrap break-words">
                              {inquiry.message}
                            </p>
                          </td>
                          <td className="px-6 py-4">
                            <span className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold font-sans ${
                              inquiry.status === 'new'
                                ? 'bg-blue-100 text-blue-800'
                                : inquiry.status === 'responded'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-gray-100 text-gray-800'
                            }`}>
                              {inquiry.status}
                            </span>
                          </td>
                          <td className="px-6 py-4">
  <select
    value={inquiry.status}
    onChange={(e) => updateInquiryStatus(inquiry.id, e.target.value)}
    className="px-3 py-2 border-2 border-gray-200 rounded-lg focus:border-rose-600 focus:outline-none text-sm font-sans"
  >
    <option value="new">New</option>
    <option value="responded">Responded</option>
    <option value="closed">Closed</option>
  </select>
</td>

                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : activeTab === 'reviews' ? (
          <>
            {/* Reviews Table */}
            <div className="card-romantic overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b-2 border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        ID
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Name
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Email
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Rating
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Review
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Date
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {reviews.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="px-6 py-12 text-center text-gray-500 font-sans">
                          No reviews yet
                        </td>
                      </tr>
                    ) : (
                      reviews.map((review) => (
                        <tr key={review.id} className="hover:bg-gray-50 transition">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            #{review.id}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-sans">
                            {review.name}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-sans">
                            {review.email}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm">
                            <div className="flex items-center gap-1">
                              {[...Array(5)].map((_, i) => (
                                <svg
                                  key={i}
                                  className={`w-4 h-4 ${
                                    i < review.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
                                  }`}
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                                </svg>
                              ))}
                              <span className="ml-2 text-gray-600">({review.rating})</span>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-900 max-w-md">
                            <div className="line-clamp-2 font-sans">{review.review}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-sans">
                            {new Date(review.created_at).toLocaleDateString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm">
                            <select
                              value={review.status}
                              onChange={(e) => handleReviewStatusChange(review.id, e.target.value)}
                              className={`rounded-full px-3 py-1 text-xs font-semibold border-0 focus:outline-none focus:ring-2 font-sans ${
                                review.status === 'approved'
                                  ? 'bg-green-100 text-green-800 focus:ring-green-500'
                                  : review.status === 'rejected'
                                  ? 'bg-red-100 text-red-800 focus:ring-red-500'
                                  : 'bg-yellow-100 text-yellow-800 focus:ring-yellow-500'
                              }`}
                            >
                              <option value="pending">Pending</option>
                              <option value="approved">Approved</option>
                              <option value="rejected">Rejected</option>
                            </select>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : activeTab === 'subscriptions' ? (
  <>
    {/* Subscriptions Stats */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 lg:gap-6 mb-6 md:mb-8">
      <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-purple-600 hover-lift">
        <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Total Subscriptions</p>
        <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">{subscriptions.length}</p>
      </div>
      <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-green-500 hover-lift">
        <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Active</p>
        <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">
          {subscriptions.filter(s => s.status === 'active').length}
        </p>
      </div>
      <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-yellow-500 hover-lift">
        <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Paused</p>
        <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">
          {subscriptions.filter(s => s.status === 'paused').length}
        </p>
      </div>
      <div className="card-romantic p-3 md:p-4 lg:p-6 border-l-4 border-red-500 hover-lift">
        <p className="text-gray-600 text-xs md:text-sm font-semibold mb-1 font-sans">Cancelled</p>
        <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">
          {subscriptions.filter(s => s.status === 'cancelled').length}
        </p>
      </div>
    </div>

    {/* Subscriptions Table */}
    <div className="card-romantic overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b-2 border-gray-200">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                ID
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                Customer
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                Plan
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                Delivery
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                Next Delivery
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                Amount
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase font-sans">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {subscriptions.length === 0 ? (
              <tr>
                <td colSpan="7" className="px-6 py-12 text-center text-gray-500 font-sans">
                  No subscriptions yet
                </td>
              </tr>
            ) : (
              subscriptions.map((sub) => (
                <tr key={sub.id} className="hover:bg-gray-50 transition">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    #{sub.id}
                  </td>
                  <td className="px-6 py-4">
                    <p className="font-semibold text-gray-900 font-sans">
                      {sub.first_name} {sub.last_name}
                    </p>
                    <p className="text-sm text-gray-600 font-sans">{sub.email}</p>
                    <p className="text-sm text-gray-600 font-sans">{sub.phone}</p>
                  </td>
                  <td className="px-6 py-4">
                    <p className="font-semibold text-gray-900 font-sans">{sub.plan_name}</p>
                    <p className="text-sm text-gray-600 font-sans">{sub.frequency}</p>
                  </td>
                  <td className="px-6 py-4">
                    <p className="text-sm text-gray-900 font-sans">
                      {sub.delivery_address}
                    </p>
                    <p className="text-sm text-gray-600 font-sans">
                      {sub.delivery_suburb} {sub.delivery_postcode}
                    </p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-sans">
                    {new Date(sub.next_delivery_date).toLocaleDateString('en-AU', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                    })}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <p className="font-bold text-lg text-gray-900">${sub.amount}</p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold font-sans ${
                      sub.status === 'active'
                        ? 'bg-green-100 text-green-800'
                        : sub.status === 'paused'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {sub.status.charAt(0).toUpperCase() + sub.status.slice(1)}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  </>
        ) : null}


        {/* Order Details Modal */}
        {selectedOrder && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 md:p-4">
            <div className="bg-white rounded-2xl md:rounded-3xl max-w-4xl w-full max-h-[95vh] md:max-h-[90vh] overflow-y-auto shadow-romantic">
              {/* ✅ Modal Header - Responsive */}
              <div className="sticky top-0 bg-white border-b-2 border-gray-200 p-4 md:p-6 flex justify-between items-center rounded-t-2xl md:rounded-t-3xl z-10">
                <div>
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-gray-900">Order Details</h2>
                  <p className="text-gray-600 font-mono text-xs md:text-sm mt-1">{selectedOrder.order_number}</p>
                </div>
                <button
                  onClick={() => setSelectedOrder(null)}
                  className="text-gray-500 hover:text-gray-700 text-3xl md:text-4xl font-light"
                >
                  ×
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-4 md:p-6 space-y-4 md:space-y-6">
                
                {/* Customer Info */}
                 <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-xl md:rounded-2xl p-4 md:p-6">
                  <h3 className="text-xl md:text-2xl font-display font-bold text-gray-900 mb-3 md:mb-4">Customer Information</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                    <div>
                      <p className="text-xs md:text-sm text-gray-600 font-sans">Name</p>
                      <p className="font-semibold text-sm md:text-base text-gray-900 font-sans">
                        {selectedOrder.first_name} {selectedOrder.last_name}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-gray-600 font-sans">Email</p>
                      <p className="font-semibold text-sm md:text-base text-gray-900 font-sans break-words">{selectedOrder.email}</p>
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-gray-600 font-sans">Phone</p>
                      <p className="font-semibold text-sm md:text-base text-gray-900 font-sans">{selectedOrder.phone}</p>
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-gray-600 font-sans">Order Date</p>
                      <p className="font-semibold text-sm md:text-base text-gray-900 font-sans">
                        {new Date(selectedOrder.created_at).toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Delivery Info */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl md:rounded-2xl p-4 md:p-6">
  <h3 className="text-2xl font-display font-bold text-gray-900 mb-4">
    {selectedOrder.delivery_method === 'pickup' ? 'Pickup Information' : 'Delivery Information'}
  </h3>
  
  <div className="grid md:grid-cols-2 gap-4">
    {/* Address - Only show for delivery */}
    {selectedOrder.delivery_method === 'delivery' && (
      <div>
        <p className="text-sm text-gray-600 font-sans">Address</p>
        <p className="font-semibold text-gray-900 font-sans">
          {selectedOrder.delivery_address}
          <br />
          {selectedOrder.delivery_suburb} {selectedOrder.delivery_postcode}
        </p>
      </div>
    )}

    {/* Pickup Location - Only show for pickup */}
    {selectedOrder.delivery_method === 'pickup' && (
      <div>
        <p className="text-sm text-gray-600 font-sans">Pickup Location</p>
        <p className="font-semibold text-gray-900 font-sans">
          Blacktown, Sydney NSW
        </p>
        <p className="text-sm text-gray-500 font-sans mt-1">By appointment only</p>
      </div>
    )}

    <div>
      <p className="text-sm text-gray-600 font-sans">
        {selectedOrder.delivery_method === 'pickup' ? 'Pickup Date & Time' : 'Delivery Date & Time'}
      </p>
      <p className="font-semibold text-gray-900 font-sans">
        {new Date(selectedOrder.delivery_date).toLocaleDateString('en-AU', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </p>
      <p className="font-semibold text-gray-900 font-sans">{selectedOrder.delivery_time}</p>
    </div>
  </div>

  {selectedOrder.special_instructions && (
    <div className="mt-4">
      <p className="text-sm text-gray-600 font-sans">Special Instructions</p>
      <p className="font-semibold text-gray-900 font-sans">{selectedOrder.special_instructions}</p>
    </div>
  )}
</div>

                {/* Order Items */}
  
<div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-xl md:rounded-2xl p-4 md:p-6">
  <h3 className="text-xl md:text-2xl font-display font-bold text-gray-900 mb-3 md:mb-4">Order Items</h3>
    <div className="space-y-3 md:space-y-4">
    {selectedOrder.items.map((item, index) => (
        <div key={index} className="bg-white rounded-lg md:rounded-xl p-3 md:p-4 shadow-soft">
        <div className="flex gap-3 md:gap-4">
          {/* ✅ Product Image Thumbnail */}
          <div className="flex-shrink-0">
            {item.customization?.image ? (
              <img
                src={item.customization.image}
                alt={item.product_name}
                className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-lg border-2 border-gray-200"
                onError={(e) => {
                  // Fallback to placeholder if image fails to load
                  e.target.onerror = null;
                  e.target.src = '/images/placeholder.jpg';
                }}
              />
            ) : (
              // Fallback if no image in customization
              <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-rose-100 to-pink-100 rounded-lg border-2 border-gray-200 flex items-center justify-center">
                <span className="text-2xl md:text-3xl">🌹</span>
              </div>
            )}
          </div>

          {/* Product Details */}
          <div className="flex-1 min-w-0">
            <div className="flex justify-between items-start mb-2">
              <div className="flex-1">
                <p className="font-bold text-sm md:text-base text-gray-900 font-sans truncate">{item.product_name}</p>
                <p className="text-xs md:text-sm text-gray-600 font-sans">Qty: {item.quantity}</p>
              </div>
              <p className="font-bold text-sm md:text-base text-gray-900 ml-2">${item.price}</p>
            </div>
            
            {/* Customization */}
{item.customization && Object.keys(item.customization).length > 0 && (
  <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-gray-200">
    <p className="text-xs md:text-sm font-semibold text-gray-700 mb-2 font-sans">Customization:</p>
    <div className="space-y-2 text-xs md:text-sm">
      
      {/* Ribbon Rose Color (single color) */}
      {item.customization.color && (
        <div className="flex justify-between items-center">
          <span className="text-gray-600 font-sans">Color:</span>
          <span className="font-semibold font-sans">{item.customization.color}</span>
        </div>
      )}
      
      {/* Real Flower Color Tones (array) */}
      {item.customization.colorTones && item.customization.colorTones.length > 0 && (
        <div>
          <span className="text-gray-600 font-sans">Color Tones:</span>
          <div className="mt-1 flex flex-wrap gap-1">
            {item.customization.colorTones.map((tone, i) => (
              <span key={i} className="inline-block bg-rose-100 text-rose-800 px-2 py-0.5 rounded-full text-xs font-semibold">
                {tone}
              </span>
            ))}
          </div>
        </div>
      )}


      
      {/* Custom Color Preference (text input) */}
      {item.customization.customColorPreference && (
        <div>
          <span className="text-gray-600 font-sans">Custom Color Preference:</span>
          <p className="mt-1 font-semibold font-sans text-rose-700">
            {item.customization.customColorPreference}
          </p>
        </div>
      )}
      
      {/* Ramo Style Count (Valentine's special) */}
      {item.customization.roseCount && (
        <div className="flex justify-between items-center">
          <span className="text-gray-600 font-sans">Rose Count:</span>
          <span className="font-semibold font-sans">
      {item.customization.roseCount}
      </span>
        </div>
      )}

      {/* Boba Balloon Color */}
{item.customization.bobaBalloonColor && (
  <div className="flex justify-between items-center">
    <span className="text-gray-600 font-sans">Boba Balloon Color:</span>
    <span className="font-semibold font-sans">
      {item.customization.bobaBalloonColor}
    </span>
  </div>
)}

{/* Valentine Rose Color */}
{item.customization.roseColor && (
  <div className="flex justify-between items-center">
    <span className="text-gray-600 font-sans">Rose Color:</span>
    <span className="font-semibold font-sans">
      {item.customization.roseColor}
    </span>
  </div>
)}

{/* Chocolate Type */}
{item.customization.chocolateType && (
  <div className="flex justify-between items-center">
    <span className="text-gray-600 font-sans">Chocolate Type:</span>
    <span className="font-semibold font-sans">
      🍫 {item.customization.chocolateType}
    </span>
  </div>
)}
      
      {/* Finish */}
      {item.customization.finish && (
        <div className="flex justify-between items-center">
          <span className="text-gray-600 font-sans">Finish:</span>
          <span className="font-semibold font-sans">{item.customization.finish}</span>
        </div>
      )}
      
      {/* Wrapping */}
      {item.customization.wrapping && (
        <div className="flex justify-between items-center">
          <span className="text-gray-600 font-sans">Wrapping:</span>
          <span className="font-semibold font-sans">{item.customization.wrapping}</span>
        </div>
      )}
      
{/* Add-ons (excluding Polaroid Photo) */}
{item.customization.addOns && item.customization.addOns.filter(addon => addon !== 'Polaroid Photo').length > 0 && (
  <div>
    <span className="text-gray-600 font-sans">Add-ons:</span>
    <div className="mt-1 space-y-0.5">
      {item.customization.addOns
        .filter(addon => addon !== 'Polaroid Photo')
        .map((addon, i) => (
          <div key={i} className="ml-2 font-semibold font-sans flex items-center gap-1">
            <span className="text-rose-600">•</span> {addon}
          </div>
        ))}
    </div>
  </div>
)}

{/* Polaroid Photo - Display separately with styling */}
{item.customization.addOns && item.customization.addOns.includes('Polaroid Photo') && (
  <div className="bg-rose-50 p-2 rounded border border-rose-200">
    <span className="text-rose-600 font-sans text-xs font-semibold flex items-center gap-1">
      📷 Polaroid photo included
    </span>
  </div>
)}

{/* Bundle Selection */}
{item.customization.bundleSelection && (
  <div className="bg-rose-50 p-2 rounded border border-rose-200">
    <span className="text-gray-600 font-sans text-xs font-semibold">🎁 Bundle:</span>
    <p className="mt-1 font-semibold font-sans text-sm">{item.customization.bundleSelection}</p>
  </div>
)}
      
      {/* Gift Message (Real flowers - required) */}
      {item.customization.giftMessage && (
        <div className="bg-purple-50 p-2 rounded border border-purple-200">
          <span className="text-gray-600 font-sans text-xs font-semibold">🎁 Gift Message:</span>
          <p className="mt-1 italic text-gray-900 font-serif text-sm">"{item.customization.giftMessage}"</p>
        </div>
      )}
      
      {/* Card Message (Ribbon roses - optional) */}
      {item.customization.cardMessage && (
        <div className="bg-blue-50 p-2 rounded border border-blue-200">
          <span className="text-gray-600 font-sans text-xs font-semibold">💌 Card Message:</span>
          <p className="mt-1 italic text-gray-900 font-serif text-sm">"{item.customization.cardMessage}"</p>
        </div>
      )}
      
      {/* Ribbon Writing */}
      {item.customization.ribbonMessage && (
        <div className="bg-pink-50 p-2 rounded border border-pink-200">
          <span className="text-gray-600 font-sans text-xs font-semibold">🎀 Ribbon Writing:</span>
          <p className="mt-1 italic text-gray-900 font-serif text-sm">"{item.customization.ribbonMessage}"</p>
        </div>
      )}
      
    </div>
  </div>
)}
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

                {/* Payment Summary */}
                <div className="bg-gray-50 rounded-xl md:rounded-2xl p-4 md:p-6">
                  <h3 className="text-xl md:text-2xl font-display font-bold text-gray-900 mb-3 md:mb-4">Payment Summary</h3>
                  <div className="space-y-2 font-sans text-sm md:text-base">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Subtotal</span>
                      <span className="font-semibold">${selectedOrder.subtotal}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Delivery Fee</span>
                      <span className="font-semibold">${selectedOrder.delivery_fee}</span>
                    </div>
                    {selectedOrder.rush_fee > 0 && (
                      <div className="flex justify-between">
                        <span className="text-yellow-700">Rush Delivery Fee</span>
                        <span className="font-semibold text-yellow-700">+${selectedOrder.rush_fee}</span>
                      </div>
                    )}
                    <div className="border-t-2 border-gray-300 pt-2 flex justify-between">
                      <span className="text-xl font-bold text-gray-900">Total</span>
                      <span className="text-xl font-bold text-rose-600">${selectedOrder.total}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Payment Status</span>
                      <span className="font-semibold text-green-600">
                        {selectedOrder.payment_status ? selectedOrder.payment_status.toUpperCase() : 'PENDING'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Update Status */}
                <div className="bg-white border-2 border-gray-200 rounded-xl md:rounded-2xl p-4 md:p-6">
                  <h3 className="text-xl md:text-2xl font-display font-bold text-gray-900 mb-3 md:mb-4">Update Order Status</h3>
                  <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
                    <button
                      onClick={() => updateOrderStatus(selectedOrder.id, 'pending')}
                      className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-white py-2 md:py-3 rounded-lg md:rounded-xl font-semibold font-sans transition text-sm md:text-base"
                    >
                      Mark as Pending
                    </button>
                    <button
                      onClick={() => updateOrderStatus(selectedOrder.id, 'confirmed')}
                      className="flex-1 bg-blue-500 hover:bg-blue-600 text-white py-2 md:py-3 rounded-lg md:rounded-xl font-semibold font-sans transition text-sm md:text-base"
                    >
                      Mark as Confirmed
                    </button>
                    <button
                      onClick={() => updateOrderStatus(selectedOrder.id, 'delivered')}
                      className="flex-1 bg-green-500 hover:bg-green-600 text-white py-2 md:py-3 rounded-lg md:rounded-xl font-semibold font-sans transition text-sm md:text-base"
                    >
                      Mark as Delivered
                    </button>
                  </div>

                   {/* ✅ ADD DELETE BUTTON HERE */}
  <div className="mt-4 pt-4 border-t-2 border-gray-200">
    <button
      onClick={() => deleteOrder(selectedOrder.id, selectedOrder.order_number)}
      className="w-full bg-red-600 hover:bg-red-700 text-white py-2 md:py-3 rounded-lg md:rounded-xl font-semibold font-sans transition text-sm md:text-base flex items-center justify-center gap-2"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
      Delete Order
    </button>
  </div>

                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default AdminDashboard;